import FormattedNumber from './FormattedNumber';

export default FormattedNumber;
